import {throttle} from "../modules/Util";

$('.js-live-search').each(function() {  
    let $productsFilterForm = $(this);
    let $productFilterName = $productsFilterForm.find('.js-live-search-input');
    let $productFilterResults = $productsFilterForm.closest('.js-location-change').find('.js-live-search-results');

    $productsFilterForm.on('submit', function (e) {
        e.preventDefault();
    });

    $productFilterName.on('input', function(e) {
        inputProductName();

        e.preventDefault();
    });

    let inputProductName = throttle(() => {
        if ($productFilterName.val().length >= 3) {
            getProductsResults();
        } else {
            $productFilterResults.removeClass('_show');
        }
    }, 350);

    function getProductsResults() {
        $.ajax({
            url: $productsFilterForm.data('search-url'),
            method: $productsFilterForm.attr('method') || 'GET',
            data: $productsFilterForm.serialize(),
            success: (response) => {
                $productFilterResults.html(response.results);
                $productFilterResults.addClass('_show');
            },
            error: () => {
                console.log('Ошибка получения данных');
            }
        });
    }    
});
